// Normalizes inline-style formatting (font-weight, font-style,
// text-decoration) to semantic <b>/<i>/<u> tags before DOMPurify
// strips the style attribute. Runs before sanitizeStoryContent in
// the WritePage paste handler.
//
// Mirrored at server/lib/normalizeRichText.js — keep in sync.
// No shared-code path exists in this repo; if you change the algorithm
// here, change it there too, and update both test files.

const STYLED_TAG_RE = /<([a-zA-Z][a-zA-Z0-9]*)\b([^>]*?\s)style\s*=\s*(["'])([^"']*)\3([^>]*)>((?:(?!<\1[\s>])[\s\S])*?)<\/\1>/gi

export function normalizeRichTextStyles(html) {
  if (typeof html !== 'string') return ''
  let prev
  let out = html
  for (let i = 0; i < 20; i++) {
    prev = out
    out = out.replace(STYLED_TAG_RE, (_m, tag, before, _q, style, after, inner) => {
      const decls = parseStyle(style)
      let wrapped = inner
      if (isItalic(decls))    wrapped = `<i>${wrapped}</i>`
      if (isBold(decls))      wrapped = `<b>${wrapped}</b>`
      if (isUnderline(decls)) wrapped = `<u>${wrapped}</u>`
      const restAttrs = `${before} ${after}`.replace(/\s+/g, ' ').trim()
      if (tag.toLowerCase() === 'span' && !restAttrs) return wrapped
      return `<${tag}${restAttrs ? ` ${restAttrs}` : ''}>${wrapped}</${tag}>`
    })
    if (out === prev) break
  }
  return out
}

function parseStyle(s) {
  const map = {}
  for (const decl of s.split(';')) {
    const idx = decl.indexOf(':')
    if (idx < 0) continue
    const key = decl.slice(0, idx).trim().toLowerCase()
    const val = decl.slice(idx + 1).trim().toLowerCase().replace(/\s*!important\s*$/, '')
    if (key) map[key] = val
  }
  return map
}

function isBold(d) {
  const w = d['font-weight']
  if (!w) return false
  return w === 'bold' || w === 'bolder' || /^(?:[6-9]\d{2}|1000)$/.test(w)
}

function isItalic(d) {
  const s = d['font-style']
  return s === 'italic' || s === 'oblique'
}

function isUnderline(d) {
  const t = d['text-decoration-line'] || d['text-decoration']
  return Boolean(t) && /\bunderline\b/.test(t)
}
